export type MktVersionTypes = "v4" | "v6";
export function versionToPathPrefix(version: MktVersionTypes) {
  if (version === "v4") return "promotion";
  if (version === "v6") return "v6";
  return `${version}`;
}
